<template>

    <div class="px-6 py-4  -mb-4">
        {{ $t('orders.address.editAddress') }}
    </div>

    <critical-banner v-if="warning" text="Die Bestellung wird bereits vom Versender bearbeitet."/>

    <jet-form-section @submitted="save()">

        <template #description>
            <div class="ml-4 mt-6 text-sm">
                <p>{{ $t('orders.address.companyNote') }}</p>
                <p class="mt-5"> {{ $t('orders.address.pickupNode') }}</p>
            </div>

        </template>

        <template #form>

            <div class="col-span-6">
                <label for="company" class="block text-sm font-medium text-gray-700">{{
                        $t("orders.address.company")
                    }}</label>
                <input type="text" name="company" id="company" v-model="form.company"
                       class="mt-1 focus:cyan-500 focus:border-cyan-500 block w-full shadow-sm sm:text-sm border-gray-300"
                       />
                <jet-input-error :message="form.errors.company" class="mt-2"/>
            </div>

            <div class="col-span-6">
                <label for="firstname" class="block text-sm font-medium text-gray-700">{{
                        $t("orders.address.firstname")
                    }}</label>
                <input type="text" name="firstname" id="firstname" v-model="form.firstname"
                       class="mt-1 focus:cyan-500 focus:border-cyan-500 block w-full shadow-sm sm:text-sm border-gray-300"
                       />
                <jet-input-error :message="form.errors.firstname" class="mt-2"/>
            </div>

            <div class="col-span-6">
                <label for="lastname" class="block text-sm font-medium text-gray-700">{{
                        $t("orders.address.lastname")
                    }}</label>
                <input type="text" name="lastname" id="lastname" v-model="form.lastname"
                       class="mt-1 focus:cyan-500 focus:border-cyan-500 block w-full shadow-sm sm:text-sm border-gray-300"
                       />
                <jet-input-error :message="form.errors.lastname" class="mt-2"/>
            </div>

            <div class="col-span-6">
                <label for="street" class="block text-sm font-medium text-gray-700">{{
                        $t("orders.address.street")
                    }}</label>
                <input type="text" name="street" id="street" v-model="form.street"
                       class="mt-1 focus:cyan-500 focus:border-cyan-500 block w-full shadow-sm sm:text-sm border-gray-300"
                       />
                <jet-input-error :message="form.errors.street" class="mt-2"/>
            </div>

            <div class="col-span-6">
                <label for="street_ext" class="block text-sm font-medium text-gray-700">{{
                        $t("orders.address.street_ext")
                    }}</label>
                <input type="text" name="street_ext" id="street_ext" v-model="form.street_ext"
                       class="mt-1 focus:cyan-500 focus:border-cyan-500 block w-full shadow-sm sm:text-sm border-gray-300"
                       />
                <jet-input-error :message="form.errors.street_ext" class="mt-2"/>
            </div>

            <div class="col-span-6">
                <label for="zip" class="block text-sm font-medium text-gray-700">{{
                        $t("orders.address.zip")
                    }}</label>
                <input type="text" name="zip" id="zip" v-model="form.zip"
                       class="mt-1 focus:cyan-500 focus:border-cyan-500 block w-full shadow-sm sm:text-sm border-gray-300"
                       />
                <jet-input-error :message="form.errors.zip" class="mt-2"/>
            </div>

            <div class="col-span-6">
                <label for="city" class="block text-sm font-medium text-gray-700">{{
                        $t("orders.address.city")
                    }}</label>
                <input type="text" name="city" id="city" v-model="form.city"
                       class="mt-1 focus:cyan-500 focus:border-cyan-500 block w-full shadow-sm sm:text-sm border-gray-300"
                       />
                <jet-input-error :message="form.errors.city" class="mt-2"/>
            </div>

            <div class="col-span-6">
                <label for="country" class="block text-sm font-medium text-gray-700">{{
                        $t("orders.address.country")
                    }}</label>
                <input type="text" name="country" id="country" v-model="form.country"
                       class="mt-1 focus:cyan-500 focus:border-cyan-500 block w-full shadow-sm sm:text-sm border-gray-300"
                       />
                <jet-input-error :message="form.errors.country" class="mt-2"/>
            </div>

        </template>

        <template #actions>
            <div class="flex justify-end my-4 mx-6">

                <button @click="cancel" type="button"
                        class="inline-block uppercase font-semibold text-xs tracking-widest">
                    {{ $t("actions.cancel") }}
                </button>

                <primary-button :class="{ 'opacity-25': form.processing }" :disabled="form.processing" class="ml-3 ">
                    {{ $t("actions.save") }}
                </primary-button>

            </div>
        </template>

    </jet-form-section>

</template>


<script>
import {defineComponent} from "vue";
import JetSecondaryButton from "@/Jetstream/SecondaryButton";
import JetFormSection from "@/Jetstream/FormSection";
import JetInput from "@/Jetstream/Input";
import JetInputError from "@/Jetstream/InputError";
import JetLabel from "@/Jetstream/Label";
import PageTitle from "@/Shared/Components/PageTitle";
import {useForm} from "@inertiajs/vue3";
import {Switch, SwitchGroup, SwitchLabel} from "@headlessui/vue";
import AppLayout from "@/Layouts/AppLayout";
import PrimaryButton from "@/Jetstream/PrimaryButton";
import CriticalBanner from "@/Pages/Sales/Order/Components/CriticalBanner";

export default defineComponent({
    props: ["address", "orderId", "warning"],
    inheritAttrs: false,
    layout: AppLayout,
    emits: ["closeModal"],
    components: {
        CriticalBanner,
        PrimaryButton,
        PageTitle,
        JetFormSection,
        JetInput,
        JetInputError,
        JetLabel,
        JetSecondaryButton,
        SwitchGroup,
        SwitchLabel,
        Switch,
    },
    methods: {
        cancel() {
            this.$emit("closeModal");
        },
        save() {
            this.form.put(this.route('sales.orders.update.address', {order: this.orderId, address: this.address.id}), {
                preserveScroll: true,
                onSuccess: () => {
                    this.$notify({
                        group: "main",
                        title: 'actions.success',
                        text: 'orders.address.updated'
                    })

                    this.cancel();
                }
            });
        }
    },
    setup(props) {

        const form = useForm({
            company: props.address.company,
            firstname: props.address.firstname,
            lastname: props.address.lastname,
            street: props.address.street,
            street_ext: props.address.street_ext,
            zip: props.address.zip,
            city: props.address.city,
            country: props.address.country,
        });

        return {form};
    }
});
</script>

<style scoped></style>
